import { Component } from '@angular/core';
import { Alert, AlertService } from '@michelin/theme';
import { AccountManagerService } from 'src/app/shared/services/distributor/account-manager.service';

@Component({
    selector: 'app-test-send-newsletter-email',
    templateUrl: './test-send-newsletter-email.component.html',
    styleUrl: './test-send-newsletter-email.component.scss',
    standalone: false
})
export class TestSendNewsletterEmailComponent {
  loading = false;

  constructor(private readonly accountManagerService: AccountManagerService, private readonly alertService: AlertService) {}

  sendTestEmail() {
    this.loading = true;
    this.accountManagerService.testSendNewsletterEmail().subscribe({
      next: () => {
        this.loading = false;
        this.alertService.showAlert({
          type: 'success',
          title: 'E-mail enviado com sucesso'
        } as Alert);
      },
      error: (error: any) => {
        this.loading = false;
        this.alertService.showAlert({
          type: 'critical',
          title: 'Erro ao enviar e-mail'
        } as Alert);
      }
    });
  }
}
